export default "./../../assets/images/grumpy.jpg";